import { Component, OnInit, Input, OnChanges, HostListener, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { McatalogConfigService } from 'src/app/services/catalogs-services/config-services/mcatalog-config.service';

@Component({
  selector: 'app-catalogs-config-gateways-card',
  templateUrl: './catalogs-config-gateways-card.component.html',
  styleUrls: ['./catalogs-config-gateways-card.component.scss']
})
export class CatalogsConfigGatewaysCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() gateways;
  @Input() mcatalogGateways;
  editingLocked;
  showForm: boolean;
  updateCatalogConfigSubscription: Subscription;

  basicDataForm = new FormGroup({});

  constructor(private mcatalogConfigService: McatalogConfigService,
              private snackbarService: SnackBarService,
              private cd: ChangeDetectorRef,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.gateways && this.mcatalogGateways) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.gateways && this.mcatalogGateways && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      this.submitForm();
      this.lockEdition();
    }
  }

  public submitForm() {
    const internalIds = [];
    Object.entries(this.basicDataForm.value).map(v => {if (v[1] === true) { internalIds.push(v[0]); }});
    this.updateCatalogConfigSubscription = this.mcatalogConfigService.updateMCatalogGateways(internalIds).subscribe(
      (res) => {
        this.editingLocked = true;
        this.snackbarService.open('catalogs-page.snackbar messages.update payments success', 'success');
        this.mcatalogConfigService.refreshMCatalogConfig();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
        this.mcatalogConfigService.refreshMCatalogConfig();
      }
    );
  }

  public resetForm() {
    this.showForm = false;
    this.gateways.forEach(g => {
      const value = this.mcatalogGateways.find(c => g.InternalId === c.InternalId) ? true : false;
      this.basicDataForm.addControl(g.InternalId, new FormControl({value, disabled: true}));
    });
    this.showForm = true;
    this.cd.detectChanges();
  }

  public unlockEdition() {
    this.basicDataForm.enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
  }

}
